import { DEGREE_TYPES, PROGRAM_DROPDOWN } from "../../ProgramMenu/form-constants";

const SELECT_DEGREE = "Select Degree";
const SELECT_PROGRAM = "Select Program";
const SELECT_SLOT = "Select Slot";

export function generateUniqueId() {
  return `uid-${Date.now()}-${Math.random().toString(36).substring(2, 10)}-${Math.random().toString(36).substring(2, 10)}`;
  }

export function formatDate(date) {
  const pad = (n) => n.toString().padStart(2, '0');

  const day = pad(date.getDate());
  const month = pad(date.getMonth() + 1); // months are 0-indexed
  const year = date.getFullYear();

  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());

  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
}

const precedentSelectedPrograms = (associatedPrograms: Array<ProgramDetails>) =>
  associatedPrograms
    .filter(
      (selectedProgram) =>
        // selectedProgram.attributes.BasicDetails?.Heading?.toUpperCase()
        !!selectedProgram.attributes.BasicDetails?.Heading,
    )
    .map(
      (selectedProgram) =>
        // selectedProgram.attributes.BasicDetails?.Heading?.toUpperCase()
        selectedProgram.attributes.BasicDetails?.Heading?.toUpperCase() ?? "",
    );

const getProgramId = ({
  isLandingPage,
  associatedPrograms,
  program,
}: {
  isLandingPage: boolean;
  associatedPrograms: Array<ProgramDetails>;
  program: String;
}) =>
  isLandingPage
    ? 
    associatedPrograms.find(
        (selectedProgram) =>
          selectedProgram.attributes.BasicDetails?.Heading?.toUpperCase() ==
          String(program).toUpperCase()
      )?.attributes.BasicDetails?.PROGRAM_ID || ''
    : PROGRAM_DROPDOWN.find((e) => String(e.title).toLowerCase() == String(program).toLowerCase())
        ?.id || "";

const filterSelectedPrograms = ({
  associatedPrograms,
  degree = SELECT_DEGREE,
}: {
  associatedPrograms: Array<ProgramDetails>;
  degree: string;
}) => {
  return associatedPrograms.filter(
    (programOption) =>
      (programOption.attributes.BasicDetails?.ProgramType === DEGREE_TYPES[degree]?.id ||
        degree == SELECT_DEGREE) &&
      !!programOption.attributes.BasicDetails?.Heading
  );
};

const aonsatAssociatedPrograms = [
  {
    __typename: "ProgramDetailsPageEntity",
    attributes: {
      __typename: "ProgramDetailsPage",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "10",
        Heading: "Master of Business Administration",
        url_key: "/master-of-business-administration-online",
        ProgramType: "PG_Program",
        SpecializationText: "75",
        PROGRAM_ID: "440",
        Custom10PgType: null,
        Brochure: {
          __typename: "UploadFileEntityResponse",
          data: {
            __typename: "UploadFileEntity",
            attributes: {
              __typename: "UploadFile",
              url: "https://amityonline.com/_s/MBA_29009413ae.pdf",
            },
          },
        },
      },
    },
  },
  {
    __typename: "ProgramDetailsPageEntity",
    attributes: {
      __typename: "ProgramDetailsPage",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "3",
        Heading: "Bachelor of Business Administration (BBA)",
        url_key: "/bachelor-of-business-administration-online",
        ProgramType: "UG_Program",
        SpecializationText: "45",
        PROGRAM_ID: "240",
        Custom10PgType: null,
        Brochure: {
          __typename: "UploadFileEntityResponse",
          data: {
            __typename: "UploadFileEntity",
            attributes: {
              __typename: "UploadFile",
              url: "https://amityonline.com/_s/Bachelor_of_Business_Administration_1feb9fc23e.pdf",
            },
          },
        },
      },
    },
  },
  {
    __typename: "ProgramDetailsPageEntity",
    attributes: {
      __typename: "ProgramDetailsPage",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "12",
        Heading: "Master of Computer Applications (MCA)",
        url_key: "/master-of-computer-applications-online",
        ProgramType: "PG_Program",
        SpecializationText: "45",
        PROGRAM_ID: "515",
        Custom10PgType: null,
        Brochure: {
          __typename: "UploadFileEntityResponse",
          data: {
            __typename: "UploadFileEntity",
            attributes: {
              __typename: "UploadFile",
              url: "https://amityonline.com/_s/Master_of_Computer_Applications_614452b7e3.pdf",
            },
          },
        },
      },
    },
  },
  {
    __typename: "ProgramDetailsPageEntity",
    attributes: {
      __typename: "ProgramDetailsPage",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "11",
        Heading: "Bachelor of Computer Applications (BCA)",
        url_key: "/bachelor-of-computer-applications-online",
        ProgramType: "UG_Program",
        SpecializationText: "45",
        PROGRAM_ID: "241",
        Custom10PgType: null,
        Brochure: {
          __typename: "UploadFileEntityResponse",
          data: {
            __typename: "UploadFileEntity",
            attributes: {
              __typename: "UploadFile",
              url: "https://amityonline.com/_s/BCA_6d5c8742ff.pdf",
            },
          },
        },
      },
    },
  },
  {
    __typename: "ProgramDetailsPageEntity",
    attributes: {
      __typename: "ProgramDetailsPage",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "13",
        Heading: "Bachelor of Commerce (B.Com)",
        url_key: "/bachelor-of-commerce-online",
        ProgramType: "UG_Program",
        SpecializationText: "45",
        PROGRAM_ID: "243",
        Custom10PgType: null,
        Brochure: {
          __typename: "UploadFileEntityResponse",
          data: {
            __typename: "UploadFileEntity",
            attributes: {
              __typename: "UploadFile",
              url: "https://amityonline.com/_s/BCOM_d8aa463b21.pdf",
            },
          },
        },
      },
    },
  },
  {
    __typename: "ProgramDetailsPageEntity",
    attributes: {
      __typename: "ProgramDetailsPage",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "14",
        Heading: "Bachelor of Arts (BA)",
        url_key: "/bachelor-of-arts-online",
        ProgramType: "UG_Program",
        SpecializationText: null,
        PROGRAM_ID: "244",
        Custom10PgType: null,
        Brochure: {
          __typename: "UploadFileEntityResponse",
          data: {
            __typename: "UploadFileEntity",
            attributes: {
              __typename: "UploadFile",
              url: "https://amityonline.com/_s/BA_Brochure_General_ba4bfc6421.pdf",
            },
          },
        },
      },
    },
  },
  {
    __typename: "ProgramDetailsPageEntity",
    attributes: {
      __typename: "ProgramDetailsPage",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "15",
        Heading: "Bachelor of Arts (BA) Journalism and Mass Communication",
        url_key: "/bachelor-of-arts-journalism-and-mass-communication-online",
        ProgramType: "UG_Program",
        SpecializationText: null,
        PROGRAM_ID: "242",
        Custom10PgType: null,
        Brochure: {
          __typename: "UploadFileEntityResponse",
          data: {
            __typename: "UploadFileEntity",
            attributes: {
              __typename: "UploadFile",
              url: "https://amityonline.com/_s/BAJMC_151cd37aa6.pdf",
            },
          },
        },
      },
    },
  },
  {
    __typename: "ProgramDetailsPageEntity",
    attributes: {
      __typename: "ProgramDetailsPage",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "16",
        Heading: "Master of Arts (MA) in Journalism and Mass Communication",
        url_key: "/master-of-arts-journalism-and-mass-communication-online",
        ProgramType: "PG_Program",
        SpecializationText: "45",
        PROGRAM_ID: "246",
        Custom10PgType: null,
        Brochure: {
          __typename: "UploadFileEntityResponse",
          data: {
            __typename: "UploadFileEntity",
            attributes: {
              __typename: "UploadFile",
              url: "https://amityonline.com/_s/MAJMC_cf51418fb6.pdf",
            },
          },
        },
      },
    },
  },
  {
    __typename: "ProgramDetailsPageEntity",
    attributes: {
      __typename: "ProgramDetailsPage",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "91",
        Heading: "BBA + MBA Degree Program",
        url_key: "/bba-mba",
        ProgramType: "UG_Program",
        SpecializationText: null,
        PROGRAM_ID: "618",
        Custom10PgType: null,
        Brochure: {
          __typename: "UploadFileEntityResponse",
          data: {
            __typename: "UploadFileEntity",
            attributes: {
              __typename: "UploadFile",
              url: "https://amityonline.com/_s/COMBO_BBA_MBA_7b644fb6e4.pdf",
            },
          },
        },
      },
    },
  },
  {
    __typename: "ProgramDetailsPageEntity",
    attributes: {
      __typename: "ProgramDetailsPage",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "92",
        Heading: "B.Com + MBA Degree Program",
        url_key: "/bcom-mba",
        ProgramType: "UG_Program",
        SpecializationText: null,
        PROGRAM_ID: "620",
        Custom10PgType: null,
        Brochure: {
          __typename: "UploadFileEntityResponse",
          data: {
            __typename: "UploadFileEntity",
            attributes: {
              __typename: "UploadFile",
              url: "https://amityonline.com/_s/COMBO_B_Com_MBA_38839788a3.pdf",
            },
          },
        },
      },
    },
  },
  {
    __typename: "ProgramDetailsPageEntity",
    attributes: {
      __typename: "ProgramDetailsPage",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "93",
        Heading: "BCA + MCA Degree Program",
        url_key: "/bca-mca",
        ProgramType: "UG_Program",
        SpecializationText: null,
        PROGRAM_ID: "619",
        Custom10PgType: null,
        Brochure: {
          __typename: "UploadFileEntityResponse",
          data: {
            __typename: "UploadFileEntity",
            attributes: {
              __typename: "UploadFile",
              url: "https://amityonline.com/_s/COMBO_BCA_MCA_016c8be349.pdf",
            },
          },
        },
      },
    },
  },
  {
    __typename: "ProgramDetailsPageEntity",
    attributes: {
      __typename: "ProgramDetailsPage",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "18",
        Heading: "Master of Commerce (M.Com) in Financial Management",
        url_key: "/master-of-commerce-financial-management-online",
        ProgramType: "PG_Program",
        SpecializationText: "45",
        PROGRAM_ID: "245",
        Custom10PgType: null,
        Brochure: {
          __typename: "UploadFileEntityResponse",
          data: {
            __typename: "UploadFileEntity",
            attributes: {
              __typename: "UploadFile",
              url: "https://amityonline.com/_s/MCOM_b51bc00b56.pdf",
            },
          },
        },
      },
    },
  },
  {
    __typename: "ProgramDetailsPageEntity",
    attributes: {
      __typename: "ProgramDetailsPage",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "56",
        Heading: "Master of Science (M.Sc) Data Science",
        url_key: "/msc-in-data-science",
        ProgramType: "PG_Program",
        SpecializationText: "45",
        PROGRAM_ID: "613",
        Custom10PgType: "HARPU-Jaipur",
        Brochure: {
          __typename: "UploadFileEntityResponse",
          data: {
            __typename: "UploadFileEntity",
            attributes: {
              __typename: "UploadFile",
              url: "https://amityonline.com/_s/M_Sc_In_Data_Science_29c131fe10.pdf",
            },
          },
        },
      },
    },
  },
  {
    __typename: "ProgramDetailsPageEntity",
    attributes: {
      __typename: "ProgramDetailsPage",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "17",
        Heading: "Master of Arts (MA) in Public Policy & Governance",
        url_key: "/ma-public-policy",
        ProgramType: "PG_Program",
        SpecializationText: "45",
        PROGRAM_ID: "608",
        Custom10PgType: null,
        Brochure: {
          __typename: "UploadFileEntityResponse",
          data: {
            __typename: "UploadFileEntity",
            attributes: {
              __typename: "UploadFile",
              url: "https://amityonline.com/_s/Master_of_Arts_MA_in_Public_Policy_and_Governance_new_f3513caa77.pdf",
            },
          },
        },
      },
    },
  },
  {
    __typename: "ProgramDetailsPageEntity",
    attributes: {
      __typename: "ProgramDetailsPage",
      BasicDetails: {
        __typename: "ComponentProgramDetailsBasicDetails",
        id: "89",
        Heading: "UG + PG Degree Program",
        url_key: "/combo-degree-program",
        ProgramType: "UG_Program",
        SpecializationText: null,
        PROGRAM_ID: "440",
        Custom10PgType: null,
        Brochure: {
          __typename: "UploadFileEntityResponse",
          data: {
            __typename: "UploadFileEntity",
            attributes: {
              __typename: "UploadFile",
              url: "https://amityonline.com/_s/Combo_degree_171af49fa3.pdf",
            },
          },
        },
      },
    },
  },
];
export { precedentSelectedPrograms, getProgramId, SELECT_DEGREE, SELECT_SLOT, SELECT_PROGRAM, filterSelectedPrograms, aonsatAssociatedPrograms };
